import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  FatoresRiscosLabels,
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteRiscoCliente, getRiscoClienteById } from '../../core/_request'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { RiscoClienteModal } from '../../components/modal/RiscoClienteModal'
import { RiscoAsoView } from '../../core/_models'

type Props = {
  risco: RiscoAsoView
}

export const RiscoActionsCell: FC<Props> = ({ risco }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  // "Risco Físico (Setor X)": o fator sozinho se repete entre linhas.
  const fator = (risco.fatorRisco && FatoresRiscosLabels[risco.fatorRisco]) || risco.nome || ''
  const nome = `Risco ${fator}${risco.setor?.nome ? ` (${risco.setor.nome})` : ''}`.trim()

  const openEditModal = () => {
    showModal({
      title: 'Risco',
      content: <RiscoClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        risco: () => getRiscoClienteById(risco.id),
      },
    })
  }

  // Excluir é destrutivo: confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir risco?',
      text: `${nome} será excluído. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteRiscoCliente(risco.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
